import { render, staticRenderFns } from "./EditVatRate.vue?vue&type=template&id=4a249e6f"
import script from "./EditVatRate.vue?vue&type=script&lang=ts"
export * from "./EditVatRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports